import { render, staticRenderFns } from "./header-step.vue?vue&type=template&id=26bc4249&scoped=true"
import script from "./header-step.vue?vue&type=script&lang=tsx"
export * from "./header-step.vue?vue&type=script&lang=tsx"
import style0 from "./header-step.vue?vue&type=style&index=0&id=26bc4249&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc4249",
  null
  
)

export default component.exports